import React from 'react';
import PropTypes from 'prop-types';

const BinanceNetworkIcon = () => (
  <svg width={21} height={21} viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.996 20.315c5.523 0 10-4.477 10-10 0-5.522-4.477-10-10-10s-10 4.478-10 10c0 5.523 4.477 10 10 10z"
      fill="#000"
    />
    <path
      d="M8.665 9.358l2.33-2.33 2.332 2.33 1.356-1.355-3.687-3.688-3.687 3.687 1.356 1.356zm-3.67.957L6.353 8.96l1.356 1.356-1.356 1.356-1.356-1.356zm3.67.958l2.33 2.33 2.332-2.331 1.357 1.355v.001l-3.688 3.687-3.688-3.688 1.357-1.354zm5.619-.957L15.64 8.96l1.356 1.356-1.356 1.356-1.356-1.356z"
      fill="#F3BA2F"
    />
    <path d="M12.371 10.315l-1.375-1.376-1.375 1.374-.002.002.002.002 1.375 1.375 1.376-1.376v-.002z" fill="#F3BA2F" />
  </svg>
);

BinanceNetworkIcon.propTypes = {};

export default BinanceNetworkIcon;
